import { graphql } from 'gql';

export const uerContractActionLogEntries = graphql(`
    query uerContractActionLogEntries(
        $skip: Int
        $take: Int
        $contractId: Long!
        $where: UerActionLogDataFilterInput
        $order: [UerActionLogDataSortInput!]
    ) {
        uerContractActionLogEntries(skip: $skip, contractId: $contractId, take: $take, where: $where, order: $order) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                contractId
                date
                entityName
                id
                userLogin
                entityDisplayName
            }
        }
    }
`);
